"use client";

import { MultiStepForm } from './components/MultiStepForm';
import { KfcProgramFormConfig } from './KfcProgramFormConfig';

export function KfcProgramForm() {
  return (
    <MultiStepForm 
      config={KfcProgramFormConfig}
      className="kfc-program-form"
    />
  );
} 